<template>
  <form>
    <input-select
      title="Тип"
      option-title-key="title"
      option-value-key="value"
      v-bind:options="itemTypes"
      v-model="selectedType"
    />
    <form-document-template-category-creation
      v-if="isSelectedCategory"
      v-bind:input-errors="inputErrors"
      v-on:on-submit="onSubmitCreateCategory"
      v-on:on-cancel="onCancel"
    />
    <form-create-clinic-document-template
      v-if="isSelectedTemplate"
      v-bind:input-errors="inputErrors"
      v-bind:categories="categories"
      v-on:cancel="onCancel"
      v-on:download-file="onDownloadFile"
      v-on:submit-document="onCreateDocumentTemplate"
      v-on:submit-contract="onCreateContractTemplate"
      v-on:preview-contract="onPreviewContractTemplate"
      v-on:preview-document="onPreviewDocumentTemplate"
      v-on:download-variables="onDownloadVariables"
    />
  </form>
</template>

<script>
import InputSelect from '@/components/InputSelect.vue';
import FormDocumentTemplateCategoryCreation from '@/components/FormDocumentTemplateCategoryCreation.vue';
import FormCreateClinicDocumentTemplate from '@/components/FormCreateClinicDocumentTemplate.vue';
import formDocumentTemplateItemMixin from '@/mixins/formDocumentTemplateItemMixin';

/**
 * @description Название события создания категории.
 * @type {string}
 */
const EVENT_NAME_CREATE_CATEGORY = 'on-create-category';

/**
 * @description Название событие создание шаблона договора.
 * @type {string}
 */
const EVENT_NAME_CREATE_CONTRACT_TEMPLATE = 'on-create-contract-template';

/**
 * @description Название событие создание шаблона документа.
 * @type {string}
 */
const EVENT_NAME_CREATE_DOCUMENT_TEMPLATE = 'on-create-document-template';

/**
 * @description Название событие отмены.
 * @type {string}
 */
const EVENT_NAME_CANCEL = 'on-cancel';

/**
 * @description Наименование события предпросмотр договора.
 * @type {string}
 */
const EVENT_NAME_PREVIEW_CONTRACT = 'on-preview-contract';

/**
 * @description Наименование события предпросмотр документа.
 * @type {string}
 */
const EVENT_NAME_PREVIEW_DOCUMENT = 'on-preview-document';

/**
 * @description Наименование события скачивания переменных.
 * @type {string}
 */
const EVENT_NAME_DOWNLOAD_VARIABLES = 'on-download-variables';

/**
 * @description Наименование события скачивания файла.
 * @type {string}
 */
const EVENT_NAME_DOWNLOAD = 'on-download';

export default {
  name: 'FormDocumentTemplateItem',
  components: {
    FormCreateClinicDocumentTemplate,
    FormDocumentTemplateCategoryCreation,
    InputSelect,
  },
  computed: {
  },
  methods: {
    /**
     * @description Скачать файл с переменными.
     * @returns {void}
     */
    onDownloadVariables() {
      this.$emit(EVENT_NAME_DOWNLOAD_VARIABLES);
    },
    /**
     * @description Создание шаблона документа.
     * @param request {ClinicTemplateRequestPreview}
     * @returns {void}
     */
    onPreviewDocumentTemplate(request) {
      this.$emit(EVENT_NAME_PREVIEW_DOCUMENT, request);
    },
    /**
     * @description Создание шаблона документа.
     * @param request {ClinicTemplateRequestPreview}
     * @returns {void}
     */
    onPreviewContractTemplate(request) {
      this.$emit(EVENT_NAME_PREVIEW_CONTRACT, request);
    },
    /**
     * @description Создание шаблона договора.
     * @param request {ClinicTemplateRequestCreate}
     * @returns {void}
     */
    onCreateContractTemplate(request) {
      this.$emit(EVENT_NAME_CREATE_CONTRACT_TEMPLATE, request);
    },
    /**
     * @description Создание шаблона документа.
     * @param request {ClinicTemplateRequestCreate}
     * @returns {void}
     */
    onCreateDocumentTemplate(request) {
      this.$emit(EVENT_NAME_CREATE_DOCUMENT_TEMPLATE, request);
    },
    /**
     * @description Обработать событие загрузки файла.
     * @param request
     */
    onDownloadFile(request) {
      this.$emit(EVENT_NAME_DOWNLOAD, request);
    },
    /**
     * @description Обработка события категории.
     *
     * @param {DocumentCategoryCreateRequest} request
     *
     * @returns {void}
     */
    onSubmitCreateCategory(request) {
      this.$emit(EVENT_NAME_CREATE_CATEGORY, request);
    },
    /**
     * @description Обработка события отмены.
     * @
     */
    onCancel() {
      this.$emit(EVENT_NAME_CANCEL);
    },
  },
  props: {
    /**
     * @description Категории.
     * @type Array
     */
    categories: {
      type: Array,
      required: true,
    },
    /**
     * @description Ошибки ввода.
     * @returns {Array}
     */
    inputErrors: { type: Object, required: true },
  },
  mixins: [
    formDocumentTemplateItemMixin,
  ],
  serviceTaxCodeOptions: [
  ],
};
</script>

<style scoped lang="scss">

</style>
